"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

/**
 * Views for the manager approval-workflow write tools (approve, send back,
 * reject lines). Merged into `concurToolRegistry` by the registry wiring.
 */
export const concurApprovalWriteToolRegistry = {
  concurApproveReport: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./approval-write-views").then(
        ({ ConcurApproveReportToolView }) => ({
          default: ConcurApproveReportToolView,
        })
      )
    ),
  },
  concurSendBackReport: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./approval-write-views").then(
        ({ ConcurSendBackReportToolView }) => ({
          default: ConcurSendBackReportToolView,
        })
      )
    ),
  },
  concurAddComment: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./approval-write-views").then(({ ConcurAddCommentToolView }) => ({
        default: ConcurAddCommentToolView,
      }))
    ),
  },
  concurRejectExpenses: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./approval-write-views").then(
        ({ ConcurRejectExpensesToolView }) => ({
          default: ConcurRejectExpensesToolView,
        })
      )
    ),
  },
} satisfies ToolUIRegistry;
